import { PairedSalesStudy } from '@aloft/toolkit-shared';
import { Button, Flex } from '@aloft/toolkit-sui';
import { Font, pdf } from '@react-pdf/renderer';

import pluralize from 'pluralize';

import { useStudiesState } from '../../../controller/hooks/useStudiesState.js';
import { StudiesExport } from './StudiesExport.js';

const FILENAME = 'Toolkit Paired Sales Export.pdf';

type Props = {
  studies: PairedSalesStudy[];
  selectedStudies: ReturnType<typeof useStudiesState>['selectedStudies'];
};

export function ExportStudiesButton({ studies, selectedStudies }: Props) {
  const numStudies = selectedStudies.length;

  const exportedStudies = studies.filter((study) => selectedStudies.includes(study.id));

  const downloadPDF = async () => {
    const blob = await pdf(<StudiesExport studies={exportedStudies} />).toBlob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;

    link.setAttribute('download', FILENAME);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  };

  const buttonText = `Export ${numStudies} ${pluralize('study', numStudies)}`;

  return (
    <Flex
      position="absolute"
      top="20px"
      width="100%"
      justifyContent="center"
      zIndex="1"
      __dangerDoNotUseSx={
        numStudies === 0
          ? { visibility: 'hidden' }
          : {
              visibility: 'visible',
              transition: 'transform 0.2s ease',
              transform: 'translateY(20px)',
            }
      }
    >
      <Button
        text={buttonText}
        onClick={() => {
          // @ts-expect-error HACK: There's no way to unregister a hyphenation callback; this lets us conditionally hyphenate between exports.
          // This is the initial state of the callback: https://github.com/diegomura/react-pdf/blob/9f7a2dffc66294f64ab39b3de68564e0a2e77ed8/packages/font/src/index.js#L9
          Font.registerHyphenationCallback(null);
          downloadPDF();
        }}
        icon="download"
        __dangerDoNotUseSx={{
          boxShadow: 'base',
        }}
      />
    </Flex>
  );
}
